// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.target-pane_target-pane_JFcaf {
  /* Makes columns for the sprite library selector + and the stage selector */
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  min-height: 0;
}

.target-pane_stage-selector-wrapper_b_YNH {
  display: flex;
  flex-basis: 72px;
  flex-shrink: 0;
}

/*
[dir="ltr"] .stage-selector-wrapper {
    margin-left: calc(\$space / 2);
}

[dir="rtl"] .stage-selector-wrapper {
    margin-right: calc(\$space / 2);
}
disable */
`, "",{"version":3,"sources":["webpack://./src/components/target-pane/target-pane.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,2EAA2E;EAC3E,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;SAQS","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.target-pane {\n  /* Makes columns for the sprite library selector + and the stage selector */\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  min-height: 0;\n}\n\n.stage-selector-wrapper {\n  display: flex;\n  flex-basis: 72px;\n  flex-shrink: 0;\n}\n\n/*\n[dir=\"ltr\"] .stage-selector-wrapper {\n    margin-left: calc($space / 2);\n}\n\n[dir=\"rtl\"] .stage-selector-wrapper {\n    margin-right: calc($space / 2);\n}\ndisable */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"target-pane": `target-pane_target-pane_JFcaf`,
	"targetPane": `target-pane_target-pane_JFcaf`,
	"stage-selector-wrapper": `target-pane_stage-selector-wrapper_b_YNH`,
	"stageSelectorWrapper": `target-pane_stage-selector-wrapper_b_YNH`
};
export default ___CSS_LOADER_EXPORT___;
